import React from "react";

function SponsoredAdIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0H16C22.6274 0 28 5.37258 28 12V16C28 22.6274 22.6274 28 16 28H12C5.37258 28 0 22.6274 0 16V12Z"
        fill="#EAECF0"
      />
      <path
        d="M13.1579 8.62952C15.8791 8.69962 18.5388 7.81308 20.6737 6.12426C20.8066 6.02456 20.9647 5.96385 21.1302 5.94893C21.2957 5.93401 21.462 5.96546 21.6107 6.03977C21.7593 6.11408 21.8843 6.22831 21.9716 6.36966C22.059 6.51101 22.1053 6.67389 22.1053 6.84005V17.5769C22.1053 17.7431 22.059 17.9059 21.9716 18.0473C21.8843 18.1886 21.7593 18.3029 21.6107 18.3772C21.462 18.4515 21.2957 18.4829 21.1302 18.468C20.9647 18.4531 20.8066 18.3924 20.6737 18.2927C18.5388 16.6039 15.8791 15.7173 13.1579 15.7874H7.78947C7.31488 15.7874 6.85972 15.5989 6.52412 15.2633C6.18853 14.9277 6 14.4725 6 13.9979V10.419C6 9.9444 6.18853 9.48924 6.52412 9.15365C6.85972 8.81806 7.31488 8.62952 7.78947 8.62952H13.1579Z"
        stroke="#424242"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.68433 15.7891C8.68433 18.1122 9.43781 20.3727 10.8317 22.2312C11.1165 22.6108 11.5404 22.8619 12.0102 22.929C12.48 22.9961 12.9573 22.8738 13.337 22.5891C13.7166 22.3043 13.9676 21.8804 14.0348 21.4106C14.1019 20.9407 13.9796 20.4635 13.6949 20.0838C12.7656 18.8448 12.2633 17.3378 12.2633 15.7891"
        stroke="#424242"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4736 8.62891V15.7868"
        stroke="#424242"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SponsoredAdIcon;
